// StreamLain related links for About dialog
// Social channels can be added here when available

export const relatedLinks: {
  icon: React.ReactNode;
  title: string;
  link: string;
}[] = [];
